import { render, staticRenderFns } from "./DlgModeratorsNew.vue?vue&type=template&id=5712fe4a&scoped=true&"
import script from "./DlgModeratorsNew.vue?vue&type=script&lang=ts&"
export * from "./DlgModeratorsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712fe4a",
  null
  
)

export default component.exports